import { API } from 'api';
import { useMutation } from 'react-query';

interface IInitEmployerAutoWithdrawal {
  payload: {
    eid: string;
  };
}

export const initEmployerAutoWithdrawal = (payload: IInitEmployerAutoWithdrawal['payload']) =>
  API.post()(`/api/admin/${payload.eid}/auto-withdrawal`, {}, undefined, 60000);

export const useInitEmployerAutoWithdrawal = () => {
  return useMutation(initEmployerAutoWithdrawal, {
    onSuccess: (response) => {
      return response.data;
    },
  });
};
